{
	"aspectRatioCustom": "Custom",
	"aspectRatioOriginal": "Original"
}
